<div class="container mt-4" style="min-height: calc(100vh - 300px);">
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class=" card-header">
                    <h5 class="font-medium m-0">📄CCL PDS Misutilization Data</h5>
                </div>
                <div class="card-body">
                           <form [formGroup]="targetForm"  (ngSubmit)="GetMisUtilizationData()">
                    <div class="row">
                        <!-- <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label">Block Office<sup class="text-danger">*</sup></label>
                            <select class="form-control">
                                <option value="" selected disabled>--Select--</option>
                            </select>
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label">Defaulter Society<sup class="text-danger">*</sup></label>
                            <select class="form-control">
                                <option value="" selected disabled>--Select--</option>
                            </select>
                        </div> -->
                  <div class="col-lg-4 col-md-6 mb-2" *ngIf="this.UserDetails?.roleId == 1">
                <label class="form-label">Circle Office <span class="text-danger">*</span></label>
                <select class="form-control" formControlName="circleOffice" (change)="GetBlock()">
                  <option value="">--Select--</option>
                  <option *ngFor="let circle of circlesList" [value]="circle?.iCircleId">
                    {{ circle?.sCircleName }}
                  </option>
                </select>
                <div *ngIf="targetForm.get('circleOffice')?.touched && targetForm.get('circleOffice')?.invalid"
                  class="text-danger small">
                  Circle office is required
                </div>
              </div>
                                        <!-- Block Office -->
                                        <div class="col-lg-3 col-md-6 mb-2">
                                            <label class="form-label">Block Office <span
                                                    class="text-danger">*</span></label>
                                            <select class="form-control" formControlName="blockOffice">
                                                <option value="" selected>--Select--</option>
                                                <option *ngFor="let circle of blockList" [value]="circle?.iBlockId">
                                                    {{ circle?.sBlockName }}
                                                </option>
                                            </select>
                                            <div class="text-danger small" style="min-height: 1.25rem;">
                                                <span
                                                    *ngIf="targetForm.get('blockOffice')?.touched && targetForm.get('blockOffice')?.invalid">
                                                    Block Office is required
                                                </span>
                                            </div>
                                        </div>

                                        <!-- Defaulter Society -->
                                        <div class="col-lg-3 col-md-6 mb-2">
                                            <label class="form-label">Defaulter Society <span
                                                    class="text-danger">*</span></label>
                                            <select class="form-control" formControlName="defaulterSociety" (click)="societyselect($event)">
                                                <option value="" selected>--Select--</option>
                                                <option *ngFor="let society of societyList" [value]="society?.defaulterSociety">
                                                    {{ society?.sSocietyName }}
                                                </option>
                                            </select>
                                            <div class="text-danger small" style="min-height: 1.25rem;">
                                                <span
                                                    *ngIf="targetForm.get('defaulterSociety')?.touched && targetForm.get('defaulterSociety')?.invalid">
                                                    Defaulter Society is required
                                                </span>
                                            </div>
                                        </div>
                                             <!-- Misutilization Since Year -->
                                        <div class="col-lg-3 col-md-6 mb-2">
                                            <label class="form-label">Misutilization Since Year <span
                                                    class="text-danger">*</span></label>
                                            <!-- <input class="form-control" type="number" formControlName="sinceYear" placeholder="Enter Year" /> -->
                                            <select class="form-control" formControlName="sinceYear" (click)="sinceYearselect($event)"
                                                >
                                                <option value="" selected>--Select--</option>
                                                <option *ngFor="let years of financialYears" [value]="years.misutilizationSinceYear">
                                                    {{ years?.misutilizationSinceYear }}
                                                </option>
                                            </select>
                                            <div class="text-danger small" style="min-height: 1.25rem;">
                                                <span
                                                    *ngIf="targetForm.get('sinceYear')?.touched && targetForm.get('sinceYear')?.invalid">
                                                    This field is required
                                                </span>
                                            </div>
                                        </div>

                                        <!-- Reporting Year (Offline Entry Year) -->
                                        <div class="col-lg-3 col-md-6 mb-2">
                                            <label class="form-label">Reporting Year<span
                                                    class="text-danger">*</span></label>
                                            <!-- <input class="form-control" type="number" formControlName="offilneEntryYear" placeholder="Enter Reporting Year" /> -->
                                            <select class="form-control" formControlName="offilneEntryYear"
                                                placeholder="Enter Reporting Year"
                                           >
                                                <option value="" selected>--Select--</option>
                                                <option *ngFor="let years of reportingYears" [value]="years?.offlineEntriesYear">
                                                    {{ years?.offlineEntriesYear }}
                                                </option>
                                            </select>
                                            <div class="text-danger small" style="min-height: 1.25rem;">
                                                <span
                                                    *ngIf="targetForm.get('offilneEntryYear')?.touched && targetForm.get('offilneEntryYear')?.invalid">
                                                    This field is required
                                                </span>
                                            </div>
                                        </div>
                        <!-- <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label">Misutilization since Year<sup class="text-danger">*</sup></label>
                            <select class="form-control">
                                <option value="" selected disabled>--Select--</option>
                            </select>
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label">Reporting Year<sup class="text-danger">*</sup></label>
                            <select class="form-control">
                                <option value="" selected disabled>--Select--</option>
                            </select>
                        </div> -->

                        <div class="col-lg-12 text-end">
                            <button type="submit" class="btn btn-primary">Get Report</button>
                        </div>
                    </div>
                    </form>
                </div>
                       </div>
        </div>

        <div class="col-lg-12">
            <div class="card">
                <div class=" card-header d-flex align-items-center justify-content-between gap-1">
                    <h5 class="font-medium m-0">📄Report</h5>
                                 <button type="button" class="btn btn-info btn-sm" data-bs-toggle="modal"
                            data-bs-target="#CCLPDSMisutilizationDataModal" (click)="addData()" 
                            *ngIf=" this.showButton &&(this.UserDetails?.roleId ==11 || this.UserDetails?.roleId ==13)">Add Data for, {{ this.currentMonth.name }} </button>
                </div>
                <div class="card-body">
                    <div class="table-responsive">
                        <!-- <table class="table table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>For Month</th>
                                    <th class="text-end">Amount Recovered (in ₹)</th>
                                    <th>Legal action taken for recovery against the defaulter</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>April, 2025</td>
                                    <td class="text-end">0.00</td>
                                    <td>Case under execution</td>
                                    <td>
                                        <div class="d-flex align-items-center gap-1">
                                            <button type="button" class="btn btn-primary btn-sm"
                                                title="Verified on 05/02/2025 04:25:00 PM"><i
                                                    class="bi bi-lock"></i></button>
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td>2</td>
                                    <td>May, 2025</td>
                                    <td class="text-end">0.00</td>
                                    <td>Case under execution</td>
                                    <td>
                                        <div class="d-flex align-items-center gap-1">
                                            <button type="button" class="btn btn-primary btn-sm" title="Click to Edit"
                                                data-bs-toggle="modal"
                                                data-bs-target="#CCLPDSMisutilizationDataModal"><i
                                                    class="bi bi-pencil-square"></i></button>
                                            <button type="button" class="btn btn-success btn-sm"
                                                title="Click to Verify"><i class="bi bi-clipboard2-check"></i></button>
                                            <button type="button" class="btn btn-danger btn-sm"
                                                title="Click to Delete"><i class="bi bi-trash3"></i></button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table> -->
                        <table class="table table-bordered table-hover">
  <thead>
    <tr>
     <th>S.No.</th>
      <th>For Month</th>
      <th class="text-end">Amount Recovered (in ₹)</th>
      <th>Legal action taken for recovery against the defaulter</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of reportData; let i = index">
      <td>{{ i + 1 }}</td>
      <td>{{ getMonthLabel(row.reportingMonth, row.reportingYear) }}</td>
      <td class="text-end">{{ row.amountRecovered.toFixed(2) }}</td>
      <td>{{ row.legalActionTaken }}</td>
      <td>
        <div class="d-flex align-items-center gap-1">
          <ng-container *ngIf="!row.isVerified && ( this.UserDetails?.roleId ==11 || this.UserDetails?.roleId ==13 ); else verifiedBlock">
         <button type="button" data-bs-toggle="modal" data-bs-target="#CCLPDSMisutilizationDataModal" class="btn btn-primary btn-sm" title="Click to Edit"
                (click)="editRow(row)">
              <i class="bi bi-pencil-square"></i>
            </button>
            <button type="button" class="btn btn-success btn-sm" title="Click to Verify" *ngIf="this.UserDetails?.roleId ==13"
               data-bs-toggle="modal" data-bs-target="#verifyConfirmModal" (click)="setDeleteIndex(row?.id)">
              <i class="bi bi-clipboard2-check"></i>
            </button>
            <button type="button" class="btn btn-danger btn-sm" title="Click to Delete"
              data-bs-toggle="modal" data-bs-target="#deleteConfirmModal"
                                                (click)="setDeleteIndex(row?.id)" >
              <i class="bi bi-trash3"></i>
            </button>
          
        </ng-container>
        <ng-template #verifiedBlock>
          <button type="button" class="btn btn-primary btn-sm" title="Verified">
            <i class="bi bi-lock"></i>
          </button>
        </ng-template>
        </div>
      </td>
    </tr>
  </tbody>
</table>
  <!-- Delete Confirmation Modal -->
                        <div class="modal fade" id="deleteConfirmModal" tabindex="-1"
                            aria-labelledby="deleteConfirmModalLabel" aria-hidden="true">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm Delete</h5>
                                        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button> -->
                                    </div>
                                    <div class="modal-body">
                                        Are you sure you want to delete ?
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary"
                                            data-bs-dismiss="modal" (click)="cancelDelete()">Cancel</button>
                                        <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                                            aria-label="Close"
                                            (click)="DeleteMisutilizationReport(deleteIndex)">Delete</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- verify Confirmation Modal -->
                        <div class="modal fade" id="verifyConfirmModal" tabindex="-1"
                            aria-labelledby="verifyConfirmModalLabel" aria-hidden="true">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm Veriication</h5>
                                        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button> -->
                                    </div>
                                    <div class="modal-body">
                                        Are you sure you want to Verify?
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary"
                                            data-bs-dismiss="modal" (click)="this.deleteIndex = 0;">Cancel</button>
                                        <button type="button" class="btn btn-success" data-bs-dismiss="modal"
                                            aria-label="Close"
                                            (click)="verifyMisutilizationReport(deleteIndex)">Verify</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- Modal -->
                <div class="modal fade" id="CCLPDSMisutilizationDataModal" data-bs-backdrop="static"
                    data-bs-keyboard="false" tabindex="-1" aria-labelledby="CCLPDSMisutilizationDataModalLabel"
                    aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl ">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h1 class="modal-title fs-5" id="CCLPDSMisutilizationDataModalLabel">Add CCL PDS
                                    Misutilization Data</h1>
                                <button type="button" class="btn-close" data-bs-dismiss="modal"
                                    aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
   <form [formGroup]="pdsForm">
                                <div class="row">

                                   

                                        <!-- Block Office -->
                                        <div class="col-lg-4 col-md-6 mb-2">
                                            <label class="form-label">Block Office <span
                                                    class="text-danger">*</span></label>
                                            <select class="form-control" formControlName="blockOffice">
                                                <option value="" selected>--Select--</option>
                                                <option *ngFor="let circle of blockList" [value]="circle?.iBlockId">
                                                    {{ circle?.sBlockName }}
                                                </option>
                                            </select>
                                            <div class="text-danger small" style="min-height: 1.25rem;">
                                                <span
                                                    *ngIf="pdsForm.get('blockOffice')?.touched && pdsForm.get('blockOffice')?.invalid">
                                                    Block Office is required
                                                </span>
                                            </div>
                                        </div>

                                        <!-- Defaulter Society -->
                                        <div class="col-lg-4 col-md-6 mb-2">
                                            <label class="form-label">Defaulter Society <span
                                                    class="text-danger">*</span></label>
                                            <select class="form-control" formControlName="defaulterSociety" >
                                                <option value="" selected>--Select--</option>
                                                <option *ngFor="let society of societyList" [value]="society?.defaulterSociety">
                                                    {{ society?.sSocietyName }}
                                                </option>
                                            </select>
                                            <div class="text-danger small" style="min-height: 1.25rem;">
                                                <span
                                                    *ngIf="pdsForm.get('defaulterSociety')?.touched && pdsForm.get('defaulterSociety')?.invalid">
                                                    Defaulter Society is required
                                                </span>
                                            </div>
                                        </div>
                                             <!-- Misutilization Since Year -->
                                        <div class="col-lg-4 col-md-6 mb-2">
                                            <label class="form-label">Misutilization Since Year <span
                                                    class="text-danger">*</span></label>
                                            <!-- <input class="form-control" type="number" formControlName="sinceYear" placeholder="Enter Year" /> -->
                                            <select class="form-control" formControlName="sinceYear"
                                                >
                                                <option value="" selected>--Select--</option>
                                                <option *ngFor="let years of financialYears" [value]="years.misutilizationSinceYear">
                                                    {{ years?.misutilizationSinceYear }}
                                                </option>
                                            </select>
                                            <div class="text-danger small" style="min-height: 1.25rem;">
                                                <span
                                                    *ngIf="pdsForm.get('sinceYear')?.touched && pdsForm.get('sinceYear')?.invalid">
                                                    This field is required
                                                </span>
                                            </div>
                                        </div>

                                        <!-- Reporting Year (Offline Entry Year) -->
                                        <div class="col-lg-4 col-md-6 mb-2">
                                            <label class="form-label">Reporting Year<span
                                                    class="text-danger">*</span></label>
                                            <!-- <input class="form-control" type="number" formControlName="offilneEntryYear" placeholder="Enter Reporting Year" /> -->
                                            <select class="form-control" formControlName="offilneEntryYear"
                                                placeholder="Enter Reporting Year"
                                           >
                                                <option value="" selected>--Select--</option>
                                                <option *ngFor="let years of reportingYears" [value]="years?.offlineEntriesYear">
                                                    {{ years?.offlineEntriesYear }}
                                                </option>
                                            </select>
                                            <div class="text-danger small" style="min-height: 1.25rem;">
                                                <span
                                                    *ngIf="pdsForm.get('offilneEntryYear')?.touched && pdsForm.get('offilneEntryYear')?.invalid">
                                                    This field is required
                                                </span>
                                            </div>
                                        </div>    
                                         
                                    <div class="col-lg-4 col-md-6 mb-2">
                                        <label class="form-label">Balance as on 01 {{ this.currentMonth.name }} <sup
                                                class="text-danger">*</sup></label>
                                        <div class="input-group">
                                            <span class="input-group-text">₹</span>
                                            <input type="text" class="form-control" formControlName="balance"
                                                placeholder="Please Fill the Data" />
                                            <span class="input-group-text">.00</span>
                                          
                                        </div>
                                           <div class="text-danger small" style="min-height: 1.25rem;">
                                                <span
                                                    *ngIf="pdsForm.get('balance')?.touched && pdsForm.get('balance')?.invalid">
                                                    This field is required
                                                </span>
                                            </div>
                                    </div>

                                    <div class="col-lg-4 col-md-6 mb-2">
                                        <label class="form-label">Amount recovered during {{ this.currentMonth.name }} <sup
                                                class="text-danger">*</sup></label>
                                        <div class="input-group">
                                            <span class="input-group-text">₹</span>
                                            <input type="text" class="form-control" formControlName="recoverAmount"
                                                placeholder="Please Fill the Data" />
                                            <span class="input-group-text">.00</span>
                                            
                                        </div>
                                         <div class="text-danger small" style="min-height: 1.25rem;">
                                                <span
                                                    *ngIf="pdsForm.get('recoverAmount')?.touched && pdsForm.get('recoverAmount')?.invalid">
                                                    This field is required
                                                </span>
                                            </div>

                                    </div>

                                    <div class="col-lg-12">
                                        <label class="form-label">Legal Action taken for recovery against the
                                            defaulter<sup>*</sup></label>
                                        <textarea class="form-control" rows="4" formControlName="actionTaken"
                                            placeholder="Case Under Execution"></textarea>
                                            
                                    </div>
                                     <div class="text-danger small" style="min-height: 1.25rem;">
                                                <span
                                                    *ngIf="pdsForm.get('actionTaken')?.touched && pdsForm.get('actionTaken')?.invalid">
                                                    This field is required
                                                </span>
                                            </div>

                                </div>
</form>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="button" class="btn btn-primary" (click)="onSubmit()">Save</button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</div>